<template>
  <div class="mt-3 flex justify-center">
    <img
      v-if="brokerLogo"
      class="mx-auto mt-8 hidden h-11 w-auto md:block"
      :src="brokerLogo"
      alt="broker logo"
    />
    <img
      v-if="brokerLogo"
      class="mx-auto h-11 w-auto md:hidden"
      :src="brokerLogo"
      alt="broker logo"
    />
  </div>
  <div class="my-4 mb-8 w-full border-t border-light-gray md:border-none" />
  <layout>
    <h3 class="mb-8 text-left text-3xl text-dark-gray">Log in</h3>
    <p class="paragraph my-5 text-left text-sm">
      Enter the mobile number associated with your Highway account.
    </p>
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <form-field
        ref="formField"
        :auto-focus="true"
        label="Mobile Phone #"
        :value="data.login_phone_number"
        placeholder="Enter Mobile #"
        :on-input="onInput"
        :on-blur="validatePhone"
        :error="phoneError"
        name="phone_number"
        type="tel"
        pattern="number"
      />
      <p class="z-20 -mt-2 text-left text-xs text-dark-blue">
        More than 50 power units?
        <router-link
          to="/login-with-email"
          class="w-max text-xs text-yellow-500 underline"
        >
          Enter email
        </router-link>
      </p>
      <button-main
        class="my-4"
        :disabled="data.login_phone_number?.length !== 12 || !!phoneError"
        type="submit"
        :loading-spinner="isLoading"
        value="Continue"
      />
    </form>

    <div class="mt-4 flex flex-col items-center">
      <p class="mb-2 text-sm text-body-color">Don't have an account?</p>
      <router-link
        to="/sign-up/carrier-details"
        class="mx-auto w-max text-sm text-yellow-500"
      >
        Sign Up
      </router-link>
    </div>
  </layout>
</template>

<script>
import Layout from '@/components/LoginLayout.vue';
import ButtonMain from '@/components/Button.vue';
import FormField from '@/components/FormField.vue';
import { formatPhone } from '@/common/validators';
import placeholderFormData from '@/common/placeholderFormData';
import { toastResponse } from '@/common/handleServerResponse';

// Mixin
import phoneField from '@/mixins/phoneField';

export default {
  name: 'Login',
  components: {
    Layout,
    ButtonMain,
    FormField,
  },
  mixins: [phoneField],
  data() {
    return {
      isLoading: false,
      data: {},
    };
  },
  computed: {
    brokerLogo() {
      return this.$store.state.brokers?.logo?.url || null;
    },
  },
  // props: {
  //   data: Object,
  // },
  mounted() {
    this.data = placeholderFormData;

    if (this.$store.state.signUpData.phone_number) {
      const phoneWithoutCountryCode =
        this.$store.state.signUpData.phone_number.slice(-10);

      this.data.login_phone_number = formatPhone(phoneWithoutCountryCode);
      this.data.login_phone_number_with_country_code =
        this.$refs?.formField?.elementData?.getNumber();
    }
  },
  async created() {
    await this.$store.dispatch(
      'brokers/getLogoByClientId',
      localStorage.getItem('client_id')
    );
  },
  methods: {
    onInput(e) {
      const value = formatPhone(e.target.value);
      if (value.length === 12) this.validatePhone(e);
      this.data.login_phone_number = value;
      this.data.login_phone_number_with_country_code =
        this.$refs?.formField?.elementData?.getNumber();

      this.$store.commit('updateSignupField', {
        name: 'phone_number',
        value: this.data.login_phone_number_with_country_code,
      });
    },
    async handleSubmit() {
      this.isLoading = true;
      const loginFromRef = this.$refs?.formField?.elementData?.getNumber();
      const res = await this.$store.dispatch('users/postSignIn', {
        phone_e164:
          this.data.login_phone_number_with_country_code || loginFromRef,
        site: 'highway.com',
      });
      if ([200, 201].includes(res.status)) {
        // phone number login success
        // send user login verification step
        this.$router.push({ name: 'LoginVerification' });
      } else {
        // Phone number does not exist -- prompt to create an account
        toastResponse(this, res, null);
      }
      this.isLoading = false;
    },
  },
};
</script>
